import { ShieldAlert, CheckCircle, XCircle } from "lucide-react";

export const AccessDeniedModal = () => (
  <div className="fixed inset-0 z-[200] bg-black/60 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-6 max-w-sm w-full text-center animate-fade-in">
      <ShieldAlert className="mx-auto w-10 h-10 sm:w-16 sm:h-16 text-red-600 mb-4" />
      <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
        Acesso Negado
      </h2>
      <p className="text-gray-600 text-sm sm:text-base">
        Caso não encontrado ou já respondido.
      </p>
    </div>
  </div>
);

export const SuccessModal = ({ modalInfo, onClose }) => (
  <div className="fixed inset-0 z-[200] bg-black/60 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-2xl p-6 sm:p-8 max-w-md w-full text-center animate-fade-in">
      <CheckCircle className="mx-auto w-12 h-12 sm:w-16 sm:h-16 text-green-600 mb-4" />
      <h2 className="text-2xl font-bold text-gray-800 mb-2">
        {modalInfo.title}
      </h2>
      <p className="text-gray-600 mb-4">
        Sua resposta foi enviada com sucesso em{" "}
        <strong className={`font-bold ${modalInfo.timeColor}`}>
          {modalInfo.responseTime}
        </strong>
        !
      </p>
      <p className="text-base text-gray-500 semibold mb-6">
        {modalInfo.encouragement}
      </p>
      <button
        onClick={onClose}
        className="px-5 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 transition"
      >
        Fechar
      </button>
    </div>
  </div>
);

export const ErrorToast = ({ message, show }) => {
  if (!show) return null;
  return (
    <div
      className="fixed top-4 inset-x-2 z-[999] flex items-center justify-start gap-2 bg-red-600 text-white p-4 rounded-lg shadow-lg animate-fade-in
                 max-w-[calc(100vw-32px)] mx-auto
                 sm:top-6 sm:right-6 sm:left-auto sm:w-auto sm:max-w-md sm:p-3 sm:gap-3"
      role="alert"
    >
      <XCircle className="w-5 h-5 flex-shrink-0" />
      <span className="font-medium text-sm sm:text-base">{message}</span>
    </div>
  );
};
export const ImageModal = ({ imageUrl, onClose }) => (
  <div
    className="fixed inset-0 z-[100] bg-black/75 flex items-center justify-center"
    onClick={onClose}
  >
    <button
      onClick={onClose}
      className="absolute top-4 right-4 text-white text-3xl font-bold"
    >
      ×
    </button>
    <div className="relative">
      <img
        src={imageUrl}
        alt="Imagem do veículo ampliada"
        className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-xl border-4 border-white"
        onClick={(e) => e.stopPropagation()}
      />
      <div className="absolute top-2 left-1/2 -translate-x-1/2 bg-black/70 text-white text-xs px-3 py-1 rounded-full shadow-md">
        Pressione ESC ou clique fora para fechar
      </div>
    </div>
  </div>
);
